<template>
  <n-button>Segment Options</n-button>
</template>
